export const MAX_FEEDBACK_LENGTH = 1000;
const WARNING_THRESHOLD = 900;

/** Kleurklasse van de tekenteller: gedempt → amber (vanaf 900) → rood (op 1000). */
export function counterTone(length: number): string {
  if (length >= MAX_FEEDBACK_LENGTH) return 'text-error-600';
  if (length >= WARNING_THRESHOLD) return 'text-warning-600';
  return 'text-muted-foreground';
}
